export default __webpack_public_path__ + "static/media/fee.15991c0d.png";